<template>
  <b-container fluid class="bg-light-grey h-100">
    <div class="vertical-center text-center">
      <h4>{{ loadingText }}</h4>
      <p id="video">
        <Animation ref="animation" />
      </p>
    </div>
  </b-container>
</template>

<script>
import Animation from "../components/loaders/animation";
import { mapGetters } from "vuex";

export default {
  name: "pages-init",
  components: {
    Animation
  },
  data() {
    return {
      payload: false
    };
  },
  created() {
    if (this.authenticated) {
      this.$gtag.event("authenticated_on_opening_plugin", { method: "Google" });
    }
    this.$store.commit(
      "opener/SET_SHOP_DOMAIN",
      new URL(document.location).searchParams.get("domain")
    );
    window.addEventListener(
      "message",
      this.$store._actions["application/receiveMessage"][0],
      false
    );
    window.onbeforeunload = () => {
      this.$store.dispatch("opener/postMessage", {
        event: "unload",
        message: {}
      });
      return undefined;
    };
    this.$store.dispatch("opener/postMessage", {
      event: "loaded",
      message: {}
    });
  },
  mounted() {
    this.$gtag.event("plugin_opened", { method: "Google" });
    var _this = this;
    setTimeout(function() {
      _this.redirect();
    }, 1050);
  },
  computed: {
    pageParamsLoaded() {
      return this.$store.getters["ui/loadedPageParams"];
    },
    ...mapGetters({
      loadingText: "ui/loadingText",
      language: "pageParams/language",
      authenticated: "auth/authenticated"
    })
  },
  methods: {
    redirect() {
      this.$i18n.locale = this.language;
      this.$router.push({ name: "overview" });
    }
  }
};
</script>

<style scoped>
.vertical-center {
  padding-top: 25%;
}

#video video {
  margin-bottom: 30px;
}
</style>
